import translation from '../../../../languages';
import './scope-of-materials.scss';

type ScopeOfMaterialsProps = TranslationProps & {
    material: Material;
};

const ScopeOfMaterials = (props: ScopeOfMaterialsProps) => {
    const { material, t } = props;

    if (Boolean(material.bundle) && material.bundleListTotal > 0) {
        return (
            <span className='scope-of-materials'>
                <li>
                    <span className='option-content'>
                        {t('common.materialBlock.totalBundleMaterials', {
                            total: material.bundleListTotal
                        })}
                    </span>
                </li>
            </span>
        );
    }

    if (material.totalPages) {
        return (
            <span className='scope-of-materials'>
                <li>
                    <span className='option-content'>
                        <>
                            {material.totalPages}{' '}
                            {material.totalPages === 1
                                ? t('materialPage.info.images.page', { count: material.totalPages })
                                : t('materialPage.info.images.page_plural', {
                                      count: material.totalPages
                                  })}
                        </>
                    </span>
                </li>
            </span>
        );
    }

    return null;
};
const translate = translation(['material-page', 'common']);

export default translate(ScopeOfMaterials);
